export default class AuthorizationError extends Error {
  constructor(
    message: string,
    public originalError?: unknown,
  ) {
    super(message)
    this.name = 'AuthorizationError'
  }
}
